import React from 'react';
import { Link } from 'react-router-dom';
import * as ReactDOM from 'react-dom';
import { LocationDescriptor } from 'history';
import LinkManager from '../../lib/LinkManager';
import Config from '../../Config';

type Props = {
    backlink: LocationDescriptor,
}

const container = document.getElementById('brand');

class PageBack extends React.Component<Props> {
    componentDidMount() {
        // @ts-ignore
        container!.firstElementChild!.style.display = 'none';
    }

    componentWillUnmount() {
        // @ts-ignore
        container!.firstElementChild!.style.display = '';
    }

    render() {
        const { backlink } = this.props;

        const mainBack = LinkManager.getMentalIndexLink() === backlink ? '-mentals' : '';

        return ReactDOM.createPortal(
            (
                <Link to={backlink} className="pagenav-back">
                    <img src={`${Config.publicImageUrl}/images/icon-back${mainBack}.svg`} alt="" />
                </Link>
            ),
            container!,
        );
    }
}

export default PageBack;
